import { faArrowLeftLong, faCoins } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  baseURL,
  EDITTACADEMAC,
  UPDATE,
  ACADIMAC,
  UPDATETMONTH,
  EDITMONTH,
} from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";

export default function UpdateMonth() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const { triggerRefresh } = useDataRefresh();

  const [loading, setLoading] = useState(false);
  const [Academacs, setAcademacs] = useState([]);
  const [data, setData] = useState({
    academicYear: "",
    chapterName: "",
    price: "",
    sortOrder: "",
    description: "",
  });
  const [image, setImage] = useState(null);

  //1/ جلب بيانات الشهر للتعديل
  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${UPDATETMONTH}/${id}/`)
          .then((res) => {
            const item = res.data?.data ?? {};
            setData({
              academicYear: item.academicYear || item.academic_year_id || "",
              chapterName: item.chapterName || item.name || "",
              price: item.price ?? "",
              sortOrder: item.sortOrder ?? item.sort_order ?? "",
              description: item.description ?? "",
            });
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل بيانات الشهر");
        });
    }
  }, [id, axiosPrivate]);

  //1/ جلب قائمة المراحل الدراسية
  useEffect(() => {
    async function fetchAcademics() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);
        setAcademacs(res.data.data);
      } catch (err) {
        console.error("Error fetching academics:", err);
      }
    }
    fetchAcademics();
  }, [axiosPrivate]);

  //1/ تغيير القيم داخل الفورم
  function handleChange(e) {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }

  //1/ حفظ التعديلات
  const handleSubmit = async (nav = false, saveAsDraft = false) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("_method", "PUT");
      formData.append("academicYear", data.academicYear);
      formData.append("chapterName", data.chapterName);
      formData.append("price", data.price);
      formData.append("sortOrder", data.sortOrder);
      formData.append("description", data.description);
      formData.append("save", saveAsDraft ? "1" : "0");
      if (image) {
        formData.append("image", image);
      }

      await axiosPrivate.post(`${baseURL}/${EDITMONTH}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("تم تعديل البيانات بنجاح");

      triggerRefresh();
      if (nav) {
        navigate("/DashboardLayout/content/months");
      }
    } catch (error) {
      console.error("حدث خطأ أثناء التعديل:", error);
      const errMsg = error.response?.data?.Message || error.response?.data?.message || "حدث خطأ أثناء التعديل، حاول مرة أخرى لاحقاً";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/content/months"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>

        <h2 className="fw-bold">تعديل شهر دراسي</h2>

        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            {/* المرحلة الدراسية */}
            <Form.Group className="mb-5" controlId="academicYear">
              <Form.Label>المرحلة الدراسية</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicYear"
                value={data.academicYear}
                onChange={handleChange}
              >
                <option value="">اختر المرحلة الدراسية</option>
                {Academacs.map((acd) => (
                  <option key={acd.id} value={acd.id}>
                    {acd.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* اسم الشهر */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="chapterName"
                value={data.chapterName}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faCalendarDays} />
                <span className="textinpout">اسم الشهر</span>
              </Form.Label>
            </Form.Group>

            {/* سعر الشهر */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="price"
                value={data.price}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faCoins} />
                <span className="textinpout">سعر الشهر</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="sortOrder"
                value={data.sortOrder}
                onChange={handleChange}
                placeholder=" "
                min={0}
                required
              />
              <Form.Label>
                <span className="textinpout">ترتيب الوحدة</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={3}
                className="inpoutFeald"
                name="description"
                value={data.description}
                onChange={handleChange}
                placeholder=" "
                style={{ height: "auto", paddingTop: "25px" }}
              />
              <Form.Label>
                <span className="textinpout">وصف الكورس / الشهر الدراسي (اختياري)</span>
              </Form.Label>
            </Form.Group>

            {/* صورة الشهر */}
            <Form.Group className="mb-5 text-end">
              <Form.Label className="small text-muted mb-2">تحديث صورة الكورس / الشهر (اتركه فارغاً للاحتفاظ بالصورة الحالية):</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </Form.Group>

            {/* الأزرار */}
            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
                disabled={loading}
              >
                حفظ
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
                disabled={loading}
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
